import { useEffect, useState } from 'react'
import { useApiGet } from '../api/apiHooks'
import { getSchedulesUrl } from '../api/urls'
import TableSkeleton from '../Component/SkeletonLoaders/TableSkeleton'
import MatchesCard from './MatchesCard'
import { groupFixturesByDate } from './groupFixturesByDate'
import PropTypes from 'prop-types'

function Matches({ leagueIdOrIdentity, seasonName }) {
  const [monthNumber, setMonthNumber] = useState(new Date().getMonth() + 1)

  const {
    data: schedulesData,
    isLoading: isApiLoading,
    isError,
    error,
  } = useApiGet({
    queryKey: [getSchedulesUrl(leagueIdOrIdentity, seasonName, monthNumber)],
    refetchInterval: 60000, // refetches every 1 minute
  })

  const groupedFixtures = groupFixturesByDate(schedulesData)

  // today local date
  const today = new Date()
  const todayLocalDate =
    today.getFullYear() +
    '-' +
    String(today.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(today.getDate()).padStart(2, '0')

  useEffect(() => {
    if (!groupedFixtures || Object.keys(groupedFixtures).length === 0) return

    // Find the date to scroll to: today or the next available
    const dates = Object.keys(groupedFixtures)
    let scrollDate = todayLocalDate
    if (!dates.includes(todayLocalDate)) {
      // Find the next date after today
      scrollDate = dates.find((date) => date > todayLocalDate) || dates[0]
    }

    const el = document.getElementById(scrollDate)
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })
    }
  }, [groupedFixtures])

  return (
    <>
      {/* season selection */}
      <div className='select-container'>
        <select
          name='season'
          className='SelectBox'
          onChange={(e) => setMonthNumber(e.target.value)}
          value={monthNumber}
        >
          <optgroup label={seasonName.split('/')[0]}>
            <option value='8'>August</option>
            <option value='9'>September</option>
            <option value='10'>October</option>
            <option value='11'>November</option>
            <option value='12'>December</option>
          </optgroup>

          <optgroup label={seasonName.split('/')[1]}>
            <option value='1'>January</option>
            <option value='2'>February</option>
            <option value='3'>March</option>
            <option value='4'>April</option>
            <option value='5'>May</option>
            <option value='6'>June</option>
            <option value='7'>July</option>
          </optgroup>
        </select>
      </div>

      {isApiLoading && <TableSkeleton rows={10} columns={1} height={150} />}
      {isError && (
        <p style={{ color: 'red' }}>
          {error.message || 'Error loading schedules'} data.
        </p>
      )}
      {schedulesData?.length === 0 && !isApiLoading && !isError && (
        <p style={{ color: 'gray' }}>No matches found for this month.</p>
      )}

      {!isApiLoading &&
        !isError &&
        Object.entries(groupedFixtures).map(([date, matches]) => {
          let displayDate = new Date(date)
            .toLocaleDateString('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric',
            })
            .replace(',', '')
          return (
            <div key={date}>
              <h3 style={{ scrollMarginTop: 200 }} id={date}>
                {displayDate}
              </h3>
              {matches.map((match) => (
                <MatchesCard key={match.id} fixture={match} />
              ))}
            </div>
          )
        })}
    </>
  )
}

export default Matches

// prop validation
Matches.propTypes = {
  leagueIdOrIdentity: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  seasonName: PropTypes.string.isRequired,
}
